import { Box, Button } from '@mui/material'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { ELECTRONIC_SUPPORTS_DOWNLOAD_SINGLE_BASE64, GET_ELECTRONIC_DOCS, Spinner } from 'shared';
import { ModalDocumentsPdf } from 'shared/components/ModalDocuments.pdf';
import { useOpenPdf } from 'shared/hooks/useOpenPdf';
import { Layout } from 'shared/utils'

export const RecoveryFeePdfView = () => {

    const { id } = useParams();
    const { documentPdf, openIframePdf, isLoading, callServicePdf, closeModalPdf } = useOpenPdf();
    const url = `${GET_ELECTRONIC_DOCS}/${ELECTRONIC_SUPPORTS_DOWNLOAD_SINGLE_BASE64}?supportId=${id}`;

    useEffect(() => {
        callServicePdf(url)
    }, [url]);

  return (
    <Layout>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
            <Button onClick={() => callServicePdf(url)}>
                Ver Documento Pdf
            </Button>
        </Box>
        { openIframePdf && <ModalDocumentsPdf document={documentPdf} openIframePdf={openIframePdf} handleOpenIframePdf={closeModalPdf}/> }
        {(isLoading) && <Spinner/>}
    </Layout>
  )
}
